import { Session } from 'next-auth'


export interface SessionAuthenticated {
  data: Session
  status: 'authenticated'
}

export interface SessionUnauthenticated {
  data: null
  status: 'unauthenticated' | 'loading'
}

const readUserFromSession = (session: Session | null | undefined) =>
  session?.user

export const extractCustomerFromClientSession = (
  session: SessionAuthenticated | SessionUnauthenticated
) => {
  return readUserFromSession(session?.data)?.customer || undefined
}

export const extractCustomerFromServerSession = (session: Session | null) => {
  return readUserFromSession(session)?.customer || undefined
}

export const extractTokenFromClientSession = (
  session: SessionAuthenticated | SessionUnauthenticated
) => {
  return readUserFromSession(session?.data)?.token || undefined
}

export const extractTokenFromServerSession = (session: Session | null) => {
  return readUserFromSession(session)?.token || undefined
}

export const extractSupportSessionExpiryFromClientSession = (
  session: SessionAuthenticated | SessionUnauthenticated
) => {
  return readUserFromSession(session?.data)?.supportSessionExpiresAt || undefined
}
